import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { addNote, editNote } from "../../api/RestCallHelper";
import FormPage from "../baseFormPage/BaseFormPage";
import FormHeader from "../../shared/FormHeader";
import TextInput from "../../shared/TextInput";
import { FormButton } from "../../styles/globalStyles";
import { ROUTES } from "../../utils/RouteConstants";
import { validateForm } from "../../utils/ValidationUtil";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";

export default () => {

  let history = useHistory();
  let location = useLocation();

  let dispatch = useFeedbackDispatch();

  const [note, setNote] = useState(null);

  const [formValidated, setFormValidated] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const isMounted = useRef(true);

  const member =  location.state.member;

  useEffect(() => {
    if (location.state.edit === true) {
      console.log("state", location.state);
      setNote(location.state.note.note);
    }
  }, [location]);

  const submit = useCallback(async () => {
    // don't send again while we are sending
    if (isSending) return;

    // update state
    setIsSending(true);

    // send the actual request
      if (location.state.edit) {
        editNote(note, member, dispatch, close, history, location);
      } else {
        addNote(note, member, dispatch, close, history, location);
      }

    // once the request is sent, update state again
    if (isMounted.current){
      // only update if we are still mounted
      setIsSending(false);
      // back();
    }
  }, [isSending, note, location, history]); // update the callback if the state changes

  const back = () => {
    if (location.state.last) {
      history.push(location.state.last, { edit : true, member : member});
    } else {
      history.push(ROUTES.MEMBERS);
    }
  };

  const close = (event, reason) => {
    console.log("In NoteForm close callback");
    if (reason === 'clickaway') return;

    dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    back();
  };

  useEffect(() => {
    setFormValidated(validateForm(note));
    console.log("note", note);
  }, [note, formValidated]);

  return (
    
    <FormPage
      logger = {console.log(note)}

      header =  { 
        <FormHeader
          heading={location.state.edit ? "Edit Note" : "Add Note"}

          subHeading= {member ? "of " + member.name + " " + member.surname : ""}
        />
      }

      form = {
        <>

          <TextInput
            label="Note"
            value={note}
            onChange={(value) => setNote(value)}
            style={{ margin: "10px" }}
          />

        </>
      }

      buttons = {
        <>
          {formValidated &&
            <FormButton
                disabled={isSending}
                onClick={submit}
            >
                {location.state.edit ? "Save" : "Add"} 
                </FormButton>   
            }

            <FormButton
                onClick={back}
                disabled={isSending}
            >
                Back
            </FormButton>
        </>
      }
    />

  );
}
